"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataServiceWrapper = void 0;
const redstone_sdk_1 = require("redstone-sdk");
const BaseWrapper_1 = require("./BaseWrapper");
const package_json_1 = require("../../package.json");
const redstone_sdk_2 = require("redstone-sdk");
class DataServiceWrapper extends BaseWrapper_1.BaseWrapper {
    constructor(dataPackagesRequestParams) {
        super();
        this.dataPackagesRequestParams = dataPackagesRequestParams;
    }
    getUnsignedMetadata() {
        const currentTimestamp = Date.now();
        return `${currentTimestamp}#${package_json_1.version}#${this.dataPackagesRequestParams.dataServiceId}`;
    }
    async getDataPackagesForPayload() {
        const dataPackagesRequestParams = await this.resolveDataPackagesRequestParams();
        const dpResponse = await (0, redstone_sdk_1.requestDataPackages)(dataPackagesRequestParams);
        return Object.values(dpResponse).flat();
    }
    async resolveDataPackagesRequestParams() {
        const fetchedParams = {
            ...this.dataPackagesRequestParams,
        };
        if (!this.dataPackagesRequestParams.uniqueSignersCount) {
            fetchedParams.uniqueSignersCount =
                await this.getUniqueSignersThresholdFromContract();
        }
        if (!this.dataPackagesRequestParams.dataServiceId) {
            fetchedParams.dataServiceId = await this.getDataServiceIdFromContract();
        }
        if (!this.dataPackagesRequestParams.urls) {
            fetchedParams.urls = (0, redstone_sdk_2.resolveDataServiceUrls)(fetchedParams.dataServiceId ??
                this.dataPackagesRequestParams.dataServiceId);
        }
        return fetchedParams;
    }
    async getDataServiceIdFromContract() {
        try {
            const dataServiceId = await this.contract.getDataServiceId();
            return dataServiceId;
        }
        catch (e) {
            throw new Error(`DataServiceId not provided and failed to get it from underlying contract. Error: ` +
                e?.message);
        }
    }
    async getUniqueSignersThresholdFromContract() {
        try {
            return await this.contract.getUniqueSignersThreshold();
        }
        catch (e) {
            throw new Error(`UniqueSignersCount not provided and failed to get it from underlying contract. Error: ` +
                e?.message);
        }
    }
}
exports.DataServiceWrapper = DataServiceWrapper;
//# sourceMappingURL=DataServiceWrapper.js.map